<div id="time-scale-picker">
<mat-form-field>
  <mat-label id="time-scale-picker-label" >{{ label }}</mat-label>
  <mat-select [(value)]="this.selectedValue"
              (selectionChange)="onScaleChanged($event.value)">
    <mat-option *ngFor="let timeUnit of timeUnitValues" [value]="timeUnit">
      {{ timeUnit }}
    </mat-option>
  </mat-select>
</mat-form-field></div>
